export enum ENotificationType {
  SOLD = 0,
  NOT_DELIVERED = 1,
  SOLD_CHINA = 2,
  NOT_DELIVERED_CHINA = 3,
  SOLD_QUALITY = 4,
}
